<div class="row h-100 m-0 p-0">
    <div class="col-lg-8 col-sm-12 pt-2">
        <dx-data-grid
            id="gridMediumContainer"
            [dataSource]="TSvc.trashMediumDataSource"
            [showBorders]="true"
            [remoteOperations]="true"
            [focusedRowEnabled]="true"
            [rowAlternationEnabled]="true"
            (onFocusedRowChanged)="onFocusedRowChanged($event)"
            [columnHidingEnabled]="true"
            [columnAutoWidth]="true"
            >
            <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>

            <dxi-column dataField="Kind" [caption]="'kind' | translateWithFallback" dataType="string">
            </dxi-column>
            <dxi-column dataField="Name" [caption]="'name' | translateWithFallback" dataType="string">
            </dxi-column>
            <dxi-column dataField="Description" [caption]="'description' | translateWithFallback"
                dataType="string" [hidingPriority]="1"> </dxi-column>
            <dxi-column dataField="Size" [caption]="'size' | translateWithFallback" dataType="number"
                [hidingPriority]="0"> </dxi-column>
            <dxi-column dataField="LastWrite" [caption]="'last-write' | translateWithFallback"
                dataType="date" format="dd/MM/yyyy hh.mm.ss" [hidingPriority]="2">
            </dxi-column>

            <dxo-filter-panel [visible]="true"></dxo-filter-panel>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-scrolling rowRenderingMode="virtual"> </dxo-scrolling>
            <dxo-paging [pageSize]="25"> </dxo-paging>
            <dxo-pager [visible]="true" [showInfo]="true" [showNavigationButtons]="true"
                [showPageSizeSelector]="true" [allowedPageSizes]="[10, 25, 50, 100]">
            </dxo-pager>
        </dx-data-grid>
    </div>
    <div class="col-lg-4 col-sm-12 p-2">
        <dx-data-grid
            class="h-100"
            id="gridVersionContainer"
            [dataSource]="TSvc.trashMediumVersionDataSource!"
            [showBorders]="true"
            [remoteOperations]="true"
            [rowAlternationEnabled]="true"
            [columnHidingEnabled]="true"
            [repaintChangesOnly]="true"
            [columnAutoWidth]="true"
            >
            <dxi-column dataField="Version" [caption]="'ver' | translateWithFallback" dataType="number"
                sortOrder="desc">
            </dxi-column>
            <dxi-column dataField="Description" [caption]="'description' | translateWithFallback"
                dataType="string" [hidingPriority]="1"> </dxi-column>
            <dxi-column dataField="Size" [caption]="'size' | translateWithFallback" dataType="number"
                [hidingPriority]="0"> </dxi-column>
            <dxi-column dataField="LastWrite" [caption]="'last-write' | translateWithFallback"
                dataType="date" format="dd/MM/yyyy hh.mm.ss" [hidingPriority]="2">
            </dxi-column>

            <dxo-load-panel [enabled]="TSvc.loadingVer"></dxo-load-panel>
            <dxi-column cellTemplate="buttonCellTemplate"></dxi-column>

            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-scrolling rowRenderingMode="virtual"> </dxo-scrolling>
        </dx-data-grid>
    </div>
</div>